"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ThemeProvider.default;
  }
});

var _ThemeProvider = _interopRequireDefault(require("./ThemeProvider"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/styles/ThemeProvider/index.js
 ** module id = 408
 ** module chunks = 0
 **/